import { apiSlice } from "./apiSlice";

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        login: builder.mutation({
            query: credentials => ({
                url: '/admin/login',
                method: 'POST',
                body: { ...credentials }
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
        getProfile: builder.query({
            query: () => ({
                url: '/admin/me',
                method: 'GET',
            }),
            transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
        }),
    })
})

export const {
    useLoginMutation,
    useLazyGetProfileQuery
} = authApiSlice